import { FC, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { HomeIcon, UsersIcon, UserGroupIcon, ShoppingBagIcon, EyeIcon, CurrencyEuroIcon, BanknotesIcon, EnvelopeIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { useNavigation } from '@utilities/hooks';
import { NavigationPathsEnum } from '@utilities/enums';

interface SidebarItem {
    label: string;
    path: NavigationPathsEnum;
    icon: typeof HomeIcon;
}

const SIDEBAR_ITEMS: SidebarItem[] = [
    { label: 'Tableau de bord', path: NavigationPathsEnum.DASHBOARD, icon: HomeIcon },
    { label: 'Commandes', path: NavigationPathsEnum.ORDERS, icon: ShoppingBagIcon },
    { label: 'Utilisateurs', path: NavigationPathsEnum.USERS, icon: UsersIcon },
    { label: 'Membres (Boutiques)', path: NavigationPathsEnum.MEMBERS, icon: UserGroupIcon },
    { label: 'Paiements', path: NavigationPathsEnum.PAYMENTS, icon: BanknotesIcon },
    { label: 'Visibilité globale', path: NavigationPathsEnum.SETTINGS_VISIBILITY, icon: EyeIcon },
    { label: 'Tarification', path: NavigationPathsEnum.SETTINGS_PRICING, icon: CurrencyEuroIcon },
    { label: 'Notifications commandes', path: NavigationPathsEnum.SETTINGS_NOTIFICATIONS, icon: EnvelopeIcon },
    { label: 'CGU / CGV', path: NavigationPathsEnum.SETTINGS_LEGAL, icon: DocumentTextIcon },
];

export const Sidebar: FC = () => {
    const { navigateTo } = useNavigation();
    const location = useLocation();

    const handleNavigate = useCallback((path: NavigationPathsEnum) => {
        navigateTo(path);
    }, [navigateTo]);

    return (
        <aside className="w-64 h-screen shrink-0 bg-white border-r border-base-300 flex flex-col sticky top-0">
            <div className="p-6 border-b border-base-300">
                <h1 className="text-xl font-bold text-primary">Suit Mesure</h1>
                <p className="text-sm text-base-content/50">Administration</p>
            </div>

            <nav className="flex-1 p-4 overflow-y-auto">
                <ul className="space-y-1">
                    {SIDEBAR_ITEMS.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <li key={item.path}>
                                <button
                                    onClick={() => handleNavigate(item.path)}
                                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive
                                        ? 'bg-primary/10 text-primary font-medium'
                                        : 'text-base-content/70 hover:bg-base-200 hover:text-base-content'
                                        }`}
                                >
                                    <item.icon className="w-5 h-5" />
                                    <span>{item.label}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
};
